
<div class="container">
  <div class="row justify-content-md-center text-center pt-4">
    <div class="col-8 col-sm-6">
      <p><strong>Orientación importante sobre el cierre de cuentas</strong></p>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col-8 col-sm-6">
      <p><strong>Eliminar la cuenta definitivamente</strong></p>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col-8 col-sm-6">
      <p>
        Una vez iniciado el proceso de eliminación, no podrás reactivar tu
        cuenta ni recuperar el contenido ni la información que hayas añadido.
      </p>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col-8 col-sm-6">
      <p>
        <strong>Reapertura de la cuenta:</strong> Su cuenta se cerrará de forma
        permanente deinmediatamente, después de los cuales no podrá volver a
        abrirla y Ecuataxi eliminará el contenido restante de su cuenta.
      </p>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col-8 col-sm-6">
      <p>
        <strong>Datos a Eliminar:</strong> 
      </p>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col-8 col-sm-6">
      <ul>
        <li>
          Información Basica como: Nombres, Apellidos, email, etc.
        </li>
        <li>
          Imagenes subidos a la plataforma de Ecuataxi.
        </li>
      </ul>
    </div>
  </div>

  <div class="row justify-content-md-center">
    <div class="col-8 col-sm-6">
      <p>
        Introduzca los datos de su cuenta para confirmar el cierre y corroborar
        que ha leído y comprendido la guía de cierre.
      </p>
    </div>
  </div>
</div>
<div class="centerVerticalForm">
  <div class="loginForm">
    <div class="container" style="margin: 2rem 2rem">
      <div class="row">
        <div class="col-6 col-sm-4 labelModal">
          <label for="float-input">Telefono:</label>
        </div>
        <div class="col-12 col-sm-8">
          <input
            class="largeInput"
            type="text"
            pInputText
            [(ngModel)]="phone"
          />
        </div>
      </div>
      <div class="row rowPad">
        <div class="col-6 col-sm-4 labelModal">
          <label for="float-input">Contraseña:</label>
        </div>
        <div class="col-12 col-sm-8">
          <input
            class="largeInput"
            type="text"
            pInputText
            [(ngModel)]="contrasena"
            type="password"
          />
        </div>
      </div>
      <div class="row rowPad">
        <div class="col-6 col-sm-4 labelModal">
          <label for="float-input">Motivo:</label>
        </div>
        <div class="col-12 col-sm-8">
          <textarea
            rows="3"
            cols="30"
            pInputTextarea
            [(ngModel)]="motivo"
            placeholder="Opcional"
            class="largeInput"
          ></textarea>
        </div>
      </div>
      <div class="row rowPad">
        <div class="col-4 offset-4">
            <p-button
            label="Borrar"
            icon="pi-solid pi-trashs"
            (onClick)="deleteAccount()"
            />
        </div>
      </div>
    </div>
  </div>
</div>
